/**
 * Wrapper minimal de BroadcastChannel('proadv.auth') para sincronizar
 * eventos de auth entre tabs (sign-out, tenant-switched).
 *
 * Fallback gracioso: se BroadcastChannel nao existir (Safari antigo,
 * ambientes restritos), publish/subscribe viram noop. Multi-tab perde
 * sincronizacao mas o app continua funcional.
 */

const CHANNEL_NAME = 'proadv.auth';

export type AuthBroadcastEvent =
  | { type: 'sign-out'; reason?: string }
  | { type: 'tenant-switched'; tenantId: string };

type Handler = (event: AuthBroadcastEvent) => void;

let channel: BroadcastChannel | null = null;
const handlers = new Set<Handler>();

function getChannel(): BroadcastChannel | null {
  if (channel) return channel;
  if (typeof BroadcastChannel === 'undefined') return null;
  try {
    channel = new BroadcastChannel(CHANNEL_NAME);
    channel.addEventListener('message', (ev: MessageEvent<AuthBroadcastEvent>) => {
      for (const h of handlers) {
        try {
          h(ev.data);
        } catch (err) {
          console.error('[broadcast] handler falhou', err);
        }
      }
    });
    return channel;
  } catch {
    return null;
  }
}

export function publish(event: AuthBroadcastEvent): void {
  const ch = getChannel();
  if (!ch) return;
  try {
    ch.postMessage(event);
  } catch {
    /* ignora */
  }
}

export function subscribe(handler: Handler): () => void {
  getChannel(); // garante init
  handlers.add(handler);
  return () => {
    handlers.delete(handler);
  };
}
